export const masks = {
  cnpj: '99.999.999/9999-99',
  cnae: '9999-9/99',
  phone: '(99) 99999-9999',
}
